import produce from 'immer'
import { v4 as uuidv4 } from 'uuid'

import {
    BoardEvent,
    DragDropListsEvents,
    ItemListBasicType,
    NewItemArgs,
    OnNewItemClickedArgs,
    OnSaveNewItemFunction,
    OptimisticLocalState,
    ServerEventStatus,
    State
} from '../../dtos'

export interface CreateNewItemProps {
    onNewItemAddServer?: DragDropListsEvents['onNewItemAdd']
    optimisticOptions?: any
    setOptimisticState: React.Dispatch<
        React.SetStateAction<OptimisticLocalState>
    >
    setState: React.Dispatch<React.SetStateAction<State>>
    state: State
}

export const createNewItem = (props: CreateNewItemProps) => {
    const {
        onNewItemAddServer,
        optimisticOptions,
        setOptimisticState,
        setState
    } = props

    const onSaveNewItemClicked: (args: OnNewItemClickedArgs) => void = async (
        args
    ) => {
        const newItem = createNewItem(args)
        // if (optimisticOptions) {
        setState((state) => {
            const nextState = produce(state, (draftState) => {
                draftState.items[newItem.id] = newItem
                if (args.index === 0) {
                    draftState.lists[args.listId].itemIds.unshift(newItem.id)
                } else {
                    draftState.lists[args.listId].itemIds.push(newItem.id)
                }
            })
            return nextState
        })
        // }

        if (onNewItemAddServer) {
            setOptimisticState((state) => {
                const nextState = produce(state, (draftState) => {
                    draftState.event.push({
                        itemId: newItem.id,
                        type: BoardEvent.create,
                        stateBeforeEvent: {
                            items: props.state.itemsBasicProps,
                            listOrder: props.state.listOrder,
                            lists: props.state.lists
                        },
                        serverEventStatus: ServerEventStatus.Loading
                    })
                })
                return nextState
            })
            try {
                const response = await onNewItemAddServer(newItem) // callback for server
                setOptimisticState((state) => {
                    const nextState = produce(state, (draftState) => {
                        // @ts-ignore
                        draftState.event.find(
                            (e) => e.itemId === newItem?.id
                        ).serverEventStatus = ServerEventStatus.Success
                    })
                    return nextState
                })
            } catch {
                setOptimisticState((state) => {
                    const nextState = produce(state, (draftState) => {
                        // @ts-ignore
                        draftState.event.find(
                            (e) => e.itemId === newItem?.id
                        ).serverEventStatus = ServerEventStatus.Error
                    })
                    return nextState
                })
            }
        } else {
            console.log('Please provide a "onNewItemAdd" props')
        }
    }

    const createNewItem: OnSaveNewItemFunction = (args) => {
        const newItemId = uuidv4()

        let newItem: NewItemArgs = {
            listId: args.listId,
            id: newItemId,
            position: args.index === 0 ? 'start' : 'end'
        }

        if (typeof args.data === 'string') {
            newItem.title = args.data
        } else {
            newItem = {
                ...newItem,
                item: { id: newItemId, position: args.index, ...args.data }
            }
        }

        return newItem
    }

    return onSaveNewItemClicked
}
